import { $http } from './config';
import { Folders, Content, Drafts, RecycledDrafts, xAPI } from './routes';

const PtApi = {
	baseURL: '',
	token: '',
	interceptors: $http.interceptors,
	axiosInstance: $http,
	...Folders,
	...Content,
	...Drafts,
	...RecycledDrafts,
	...xAPI
};

export default PtApi;
